export const EMPTY_VALUE = null;
